var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticStyle:{"text-align":"center","color":"#655F49","margin":"5em"}},[_vm._v("Il semblerait que vous soyez perdus...")])])}]

export { render, staticRenderFns }